import { Component, OnInit, Input, HostListener } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import { Router, ActivatedRoute, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { ToastrService } from 'ngx-toastr';
import { isNullOrUndefined } from 'util';
import {BehaviorSubject}  from 'rxjs';
import { EncdecService } from 'src/app/services/encdec.service';
import {  CookieService  } from 'ngx-cookie-service'; 
import { TranslateService } from '@ngx-translate/core';
import { HttpClient  } from '@angular/common/http';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  validation : object = {login : true,password:true,captcha : true};
  UserData : object = {login:'',password:''};
  validusertypes = ["central","state","district","field"];
  captchaimage = null;
  activespineer : boolean;
  @Input() fromdatasubmit;
  @Input() urlParams
  show_button: boolean = false;
  show_eye: boolean = false;
  capslockOn: boolean;
  ipAddress: any;
  Roleuser: any;
  usernameid: any;
  constructor(public activeModal :NgbActiveModal,
    public utils : UtilsModule,
    public constants : ConstantsModule,
    private translate: TranslateService,
    private loginSrv : AuthloginService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr : ToastrService,
    private encdecservice : EncdecService,
    private cookie : CookieService,
    private http:HttpClient
    ) {
      translate.setDefaultLang('en');
     }
    private loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(this.isLoggedIn());

  ngOnInit() {
    this.captchaimage = this.loginSrv.getcaptchaimageapi();
    this.loginSrv.getIPAddress();
    this.callCaptchaimage();
  }
  callCaptchaimage(){
    let imageObject = document.getElementById("capthaId");
    imageObject['src'] = this.captchaimage+'?time='+new Date()
  }
  reloadCaptcha(){
    // this.captchaimage = this.loginSrv.getcaptchaimageapi();
    // this.callCaptchaimage();
    this.ngOnInit()
  }
  // getIPAddress()
  // {
  //   this.http.get("https://api.ipify.org/?format=json").subscribe((res:any)=>{
  //     this.ipAddress = res.ip;
  //     console.log("lgn_ip",this.ipAddress)
  //   });
  // }
  public loginClick(){
    if(this.basicValidation()){
        this.activespineer = true;
        let that = this;
        let urlParams ={};
        let postData={
          "username": this.encdecservice.rsaenc(this.constants.PUBLIC_KEY,this.UserData['login']+","+this.UserData['password']),
          "lock" : true,
          "captchaResponse" : this.encdecservice.rsaenc(this.constants.PUBLIC_KEY,this.UserData['captcha']),
          "userInfoEncrypted" : true,
          // "ipAddress":this.loginSrv.ipAddress
        }
        // console.log(postData)
        this.loginSrv.getuserlogin(postData).subscribe(logresp =>{          
          // var logresp = this.loginSrv.geteuserlogindummy();
          if(logresp['result']['success']){
            var formattedResp = this.formatData(logresp);

          }
          this.activespineer = false;
          
          if(this.Roleuser != this.usernameid){
            this.loginSrv.logoutuserandsessionclear();
          } else{

            if(logresp['result']['success']){
              this.toastr.success("Logged In Successfully")
              
              this.activeModal.dismiss('Cross click');
              // let user = {loggedOut: false,
              //   loggedSuccess: true,
              //   roles: [`${this.UserData['login']}`],
              //   accesssidetabs : this.constants.ROLEBASEDSIDETABMAP[this.UserData['login']],
              //   sessionID: 77842,
              //   sessionKey: "3fcf191f-c18b-47cd-a9b5-390c9dea7394"}
                // logresp['accesssidetabs'] = this.constants.ROLEBASEDSIDETABMAP[logresp['roles'][0]]
                // this.loginSrv.createsession(logresp);
                // this.activeModal.dismiss('Cross click');
                if(this.fromdatasubmit){
                  urlParams = {'component': this.constants.ROLEBASEDDEFAULTCOMP[logresp['result']['content']['userDetails']['roles'][0]]};
                   
                  
                this.router.navigate(["/submitdata",  urlParams]);
                }
                else{
                  setTimeout(() => {
                    this.urlParams = {};
                    // var  urlParams = this.utils.getWritableObject(this.route.snapshot.params);
                     this.urlParams['locname']=logresp['result']['content']['userDetails']['userDetailsJson']['locationName']?logresp['result']['content']['userDetails']['userDetailsJson']['locationName'] :'INDIA';
                     this.urlParams['loctype']=logresp['result']['content']['userDetails']['userDetailsJson']['locationType']? logresp['result']['content']['userDetails']['userDetailsJson']['locationType']: 'COUNTRY';
                     this.urlParams['locuuid']=logresp['result']['content']['userDetails']['userDetailsJson']['locationId']? logresp['result']['content']['userDetails']['userDetailsJson']['locationId']: "ffce954d-24e1-494b-ba7e-0931d8ad6085";
                     this.urlParams['stateuuid']=logresp['result']['content']['userDetails']['userDetailsJson']['stateId']?logresp['result']['content']['userDetails']['userDetailsJson']['stateId']:'ffce954d-24e1-494b-ba7e-0931d8ad6085'
                     delete this.urlParams["parentLocName"]; 
                    this.router.navigate(["/gis", this.constants.DEFAULT_COUNTRY, this.urlParams]);
                    location.reload();
                     }, 10);
                } 
                var content = logresp['result']['content'];
                localStorage.setItem('USERID',content['userDetails']['userId']);
                localStorage.setItem('ACCESS_TOKEN', content['token']);
                localStorage.setItem('USER_INFO', JSON.stringify(this.createUserInfos(content['userDetails'])));
                localStorage.setItem('USER_DETAILS_INFO', JSON.stringify(this.createUserDetail(content['userDetails']['userDetailsJson'])));
  
                this.loginSrv.createsession(formattedResp);
                this.loggedIn.next(true);
            }else{
              this.loginSrv.clearsession();
              this.loggedIn.next(false);
              this.toastr.error(logresp['result']['message']);
              this.UserData = {login:'',password:'',captcha:''};
              // grecaptcha.reset();
              this.callCaptchaimage();
              }
          }
        },function(err){
          that.activespineer = false;
          if(err['error']){
            that.toastr.error(err['error']['msg'])
            this.clearfields();
            this.callCaptchaimage();
            // grecaptcha.reset();
          }
        })
     }
   
  }
  clearfields(){
    this.UserData = {login:'',password:''};
  }
  public createUserInfos(userData) {
    var obj = {};
    if(userData === null){
    return obj;
    }
    obj['firstName'] = userData['firstName'];
    obj['lastName'] = userData['lastName'];
    obj['email'] = userData['email'];
    obj['mobileNo'] = userData['mobileNo'];
    obj['roles'] = userData['roles'];
    obj['userId'] = userData['userId'];
    return obj;
    
  }
    public createUserDetail(data: any) {
      let obj:any = {};
      if(isNullOrUndefined(data)) {
      return obj;
      }
      for(let key in data) {
      if(key.indexOf('secondary') == -1 && key.indexOf('bbox') == -1) {
      obj[key] = data[key];
      }
      }
     // console.log("\n user Detials Json obj \n ", obj);
      return obj;
  }

  public isLoggedIn() {
    let token = localStorage.getItem('ACCESS_TOKEN');
    if (token && token !== "" && !isNullOrUndefined(token)) {
    return true;
    }
    return false;
    }

  basicValidation(){
    if(this.utils.checkfield(this.UserData['login'])){
      this.validation['login'] = true;
    }else{
      this.validation['login'] = false;
    }

    if(this.utils.checkfield(this.UserData['password'])){
      this.validation['password'] = true;
    }else{
      this.validation['password'] = false;
    }
    if(this.utils.checkfield(this.UserData['captcha'])){
      this.validation['captcha'] = true;
    } else {
      this.validation['captcha'] = false;
    }
    return this.validation['password'] && this.validation['login'] && this.validation['captcha'];
  } 
  showPassword() {
    this.show_button = !this.show_button;
    this.show_eye = !this.show_eye;
  }

  validateOnchange(type){
    if(this.utils.checkfield(this.UserData[type])){
      this.validation[type] = true;
    }else{
      this.validation[type] = false;
    }
  } 
  formatData(logresp){
    let loginUser = {};
              loginUser['login'] = logresp['result']['content']['userDetails']['username'];
              loginUser['roles'] = this.encdecservice.rsadec(this.constants.PRIVATE_KEY,logresp['result']['content']['userDetails']['roles'][0]);
              loginUser['roles'] = loginUser['roles'].split("VG$$PK");
              this.Roleuser = loginUser['roles'][1];
              loginUser['usernameid'] = this.encdecservice.rsadec(this.constants.PRIVATE_KEY,loginUser['login']);
              this.usernameid = loginUser['usernameid'];

              loginUser['accesssidetabs'] = this.constants.ROLEBASEDSIDETABMAP[loginUser['roles'][0]];
              // logresp['accesssidetabs'] = this.constants.ROLEBASEDSIDETABMAP[logresp['result']['content']['userDetails']['roles'][0]];
              loginUser['sessionKey'] = logresp['result']['content']['token'];
              loginUser['expirationTime'] = logresp['result']['content']['expirationTime'];
              loginUser['loggedSuccess'] = true;
              loginUser['isReadOnly'] = logresp['result']['content']['userDetails']['userDetailsJson']['isReadOnly'];
              loginUser['loggedOut'] = false;
              loginUser['loginTs'] = logresp['result']['content']['loginTs'];
              
              loginUser['loggedUserData'] = {
                "userProfile": {
                  "userId": logresp['result']['content']['userDetails']['userId']?logresp['result']['content']['userDetails']['userId']:null,
                  "lname": logresp['result']['content']['userDetails']['lastName']?logresp['result']['content']['userDetails']['lastName']:null,
                  "fname": logresp['result']['content']['userDetails']['firstName']?logresp['result']['content']['userDetails']['firstName']:null,
                  "stateName": logresp['result']['content']['userDetails']['userDetailsJson']['stateName']?logresp['result']['content']['userDetails']['userDetailsJson']['stateName']:null,
                  "countryName": logresp['result']['content']['userDetails']['userDetailsJson']['countryName']?logresp['result']['content']['userDetails']['userDetailsJson']['countryName']:null,
                  "stateUUID": logresp['result']['content']['userDetails']['userDetailsJson']['stateId']?logresp['result']['content']['userDetails']['userDetailsJson']['stateId']:null,
                  "countryUUID": logresp['result']['content']['userDetails']['userDetailsJson']['countryId']?logresp['result']['content']['userDetails']['userDetailsJson']['countryId']:null,
                  "locationId":  logresp['result']['content']['userDetails']['userDetailsJson']['locationId']?logresp['result']['content']['userDetails']['userDetailsJson']['locationId']:null,
                  "locationName": logresp['result']['content']['userDetails']['userDetailsJson']['locationName']?logresp['result']['content']['userDetails']['userDetailsJson']['locationName']:null,
                  "locationType": logresp['result']['content']['userDetails']['userDetailsJson']['locationType']?logresp['result']['content']['userDetails']['userDetailsJson']['locationType']:null,
                  "associatedlocationsDetails": [
                    {
                      "entityName": logresp['result']['content']['userDetails']['userDetailsJson']['locationName']?logresp['result']['content']['userDetails']['userDetailsJson']['locationName']:null,
                      "entityUUID": logresp['result']['content']['userDetails']['userDetailsJson']['permissions'] ? logresp['result']['content']['userDetails']['userDetailsJson']['permissions']['25']['PERMITTED'][0]['entityList'][0]:null,
                      "entityType": logresp['result']['content']['userDetails']['userDetailsJson']['permissions'] ? logresp['result']['content']['userDetails']['userDetailsJson']['permissions']['25']['PERMITTED'][0]['entityType'] :null
                    }
                  ]
                },
              };
              return loginUser;
    
  }

  addScript() {
    let script = document.createElement('script');
    // const lang = this.lang ? '&hl=' + this.lang : '';
    script.src = `https://www.google.com/recaptcha/api.js?onload=reCaptchaLoad`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }
  public openresetpopup(){
    if(this.basicValidationforreset()){
      this.activespineer = true;
      let postdata = {'username':this.UserData['login'],'captchaResponse' : this.encdecservice.rsaenc(this.constants.PUBLIC_KEY,this.UserData['captcha'])}
      this.loginSrv.checkuserforresetpwd(postdata).subscribe(res =>{
        if(res.result.success){
          this.toastr.success(res.result.content);
          this.activeModal.dismiss('Cross click');
          this.router.navigate(["/reset",{}]);
        } else {
            this.toastr.error(res.result.content);
            this.UserData = {login:'',password:''};
            // grecaptcha.reset();
            this.callCaptchaimage();
        }
        this.activespineer = false;
      },function(err){
        this.toastr.error(err)
      })
    }
  }
  checkValidation(event) {
    let input = document.getElementById("username");
    let warnText = document.getElementById("warn");
    input.addEventListener("keyup", function (event) {
      if (event.getModifierState("CapsLock")) {
        warnText.style.display = "block";
      } else {
        warnText.style.display = "none";
      }
    });
  }
  checkvalidation(event) {
    let pwdobj = document.getElementById("password");
    let warnText = document.getElementById("warning");
    pwdobj.addEventListener("keyup", function (event) {
      if (event.getModifierState("CapsLock")) {
        warnText.style.display = "block";
      } else {
        warnText.style.display = "none";
      }
    });
  }
  basicValidationforreset(){
    if(this.utils.checkfield(this.UserData['login'])){
      this.validation['login'] = true;
    }else{
      this.validation['login'] = false;
    }
    if(this.utils.checkfield(this.UserData['captcha'])){
      this.validation['captcha'] = true;
    } else {
      this.validation['captcha'] = false;
    }
    console.log(this.validation)
    return this.validation['login'] && this.validation['captcha'];
  }
  

}
